import MemberTypeRepository from '@repository/MemberTypeRepository'
import MemberGroupRepository from '@repository/MemberGroupRepository'
import { orderableKinds } from './Commissioning/policyCatalogue'

/**
 * Lire un réglage d'inscription comme un humain : son libellé, le libellé de sa valeur, et le nom
 * des objets qu'il désigne (groupes, type de membre, site) plutôt que leur identifiant.
 *
 * Partagé par l'écran de configuration et le dossier d'inscription, pour que les deux disent la
 * même chose du même réglage.
 */
export default {
  data() {
    return {
      // réglage → objets de l'organisation qu'il peut désigner ({ id, name })
      pickers: {},
    }
  },

  methods: {
    async loadPickers(organizationId) {
      const search = { organizationId, offset: 0, limit: 200 }
      const [types, groups, equipment] = await Promise.all([
        MemberTypeRepository.search(search).catch(() => ({ items: [] })),
        MemberGroupRepository.search(search).catch(() => ({ items: [] })),
        orderableKinds(organizationId).catch(() => []),
      ])
      this.pickers = {
        'membership.member-type': types.items || [],
        'membership.groups': groups.items || [],
        // Les équipements que l'adhésion annonce : des types de commande, nommés.
        'membership.equipment': equipment.map(kind => ({ id: kind, name: this.$t(`onboarding.commissioning.kind.${kind}`) })),
      }
    },

    labelOf(key) {
      const k = `onboarding.configuration.setting.${key}`
      return this.$te(k) ? this.$t(k) : key
    },

    /** Le libellé d'une valeur ; propre au réglage quand la même valeur y dit autre chose (« borne » commandée d'office). */
    valueLabel(value, key = null) {
      const specific = key ? `onboarding.configuration.setting-value.${key}.${value}` : null
      if (specific && this.$te(specific)) return this.$t(specific)
      const k = `onboarding.configuration.value.${value}`
      return this.$te(k) ? this.$t(k) : value
    },

    /** La valeur d'un réglage, en mots : oui/non, libellés, noms des objets désignés. */
    render(key, value) {
      if (value === null || value === undefined || value === '') return '-'
      if (typeof value === 'boolean') return value ? this.$t('yes') : this.$t('no')
      if (Array.isArray(value)) return value.length ? value.map(v => this.nameIn(key, v)).join(', ') : '-'
      if (typeof value === 'object') return JSON.stringify(value)
      return this.nameIn(key, value)
    },

    nameIn(key, value) {
      const item = (this.pickers[key] || []).find(i => i.id === value)
      return item ? item.name : this.valueLabel(value, key)
    },
  },
}
